/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/drafts/ratatouille.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/drafts/ratatouille.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/ratatouille.mdx';

const metadata = {
  slug: "ratatouille",
  title: "Ratatouille",
  author: "Christian Battaglia",
  description: "Building @dtw/ratatouille — a lightweight deployment tool to replace Chef with hash-verified deploy scripts in TypeScript and Bash. Like Chef, but without the bad bits.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2019-12-01T00:00:00.000Z",
  
  readTime: "3 min read",
  tags: ["DevOps","deployment","Bash","TypeScript","configuration management","infrastructure","Chef","Deno","open source"],
};

export const Route = createFileRoute('/blog/posts/ratatouille')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/ratatouille',
    image: '/og/blog/ratatouille.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
